import { API_BASE_URL } from "./BaseUrl";

const baseUrl = API_BASE_URL + "api";
const apiUrl = "api";

const ExternalRoutes = {
  authConfig: {
    inscription: baseUrl + "/register",
    login: baseUrl + "/login",
    forgotPassword: baseUrl + "/forgot-password",
    resetPassword: baseUrl + "/reset-password/"
  },
  document: {
    list_by_user: baseUrl + "/users/con_documents/",
    show: baseUrl + "/con_documents/",
    add: baseUrl + "/document/create",
    delete: baseUrl + "/con_documents/",
    edit: baseUrl + "/document/update/",
    isSubmit: baseUrl + "/document/submit_document/",
    conDocuments: baseUrl +"/con_documents",
    update_status: baseUrl + "/document/update_status/",
    detail : baseUrl + "/document/detail",
  },
  doc_status:{
    list:baseUrl + "/con_document_statuses"
  },
  userInformation: {
    edit: baseUrl + "/user/informations",
    editPassword: baseUrl + "/user/update-password",
    show: baseUrl + "/users/",
    showAdd: apiUrl + "/users/",
    editBo:  baseUrl + "/users/",
  },
  history: {
    list: baseUrl + "/con_histories/"
  },
  society: {
    add: baseUrl + "/society/create",
    get_by_user: baseUrl + "/users_societies/",
    delete_file: baseUrl + "/society/files/",
    list: baseUrl + "/con_societies"
  },
  callRemember: {
    add: baseUrl + "/con_call_remembers/add",
    show: baseUrl + "/users/con_call_remembers/",
    list: baseUrl + "/con_call_remembers",
    edit: baseUrl + "/con_call_remembers/"
  },
  subscription: {
    list: baseUrl + "/con_subscriptions",
    payment: baseUrl + "/con_subscriptions/subscribe",
    succeeded: baseUrl +  "/con_subscriptions/payment/success",
    by_user: baseUrl + "/con_user_subscription/by_user",
    list_by_user: baseUrl + "/users/con_user_subscriptions/"
  },
  status: {
    list: baseUrl + "/con_document_statuses"
  },
  users:{
    list:baseUrl + "/users"
  }
};

export default ExternalRoutes;